module.exports = __webpack_public_path__ + "static/CVS-Catch-DLB-7-8-STEM-V4.1-ee4a63f9886f7442d9f1676bf6921798.pdf";